export const ACCOUNT_BASED_MARKETING = 'ACCOUNT_BASED_MARKETING';
export const ACCOUNTING = 'ACCOUNTING';
export const ADVERTISING = 'ADVERTISING';
export const APPLICANT_TRACKING_SYSTEMS = 'APPLICANT_TRACKING_SYSTEMS';
export const CALLING = 'CALLING';
export const COLLABORATION = 'COLLABORATION';
export const COMPETITIVE_INTELLIGENCE = 'COMPETITIVE_INTELLIGENCE';
export const CONNECTOR = 'CONNECTOR';
export const CONSENT_MANAGEMENT = 'CONSENT_MANAGEMENT';
export const CONTENT_MANAGEMENT_SYSTEM = 'CONTENT_MANAGEMENT_SYSTEM';
export const CONVERSATION_INTELLIGENCE = 'CONVERSATION_INTELLIGENCE';
export const CPQ = 'CPQ';
export const CRM = 'CRM';
export const CUSTOMER_SUCCESS = 'CUSTOMER_SUCCESS';
export const DATA_MIGRATION = 'DATA_MIGRATION';
export const DATA_QUALITY_BACKUP = 'DATA_QUALITY_BACKUP';
export const DIGITAL_PLATFORM_ADOPTION = 'DIGITAL_PLATFORM_ADOPTION';
export const DIRECT_MAIL_AUTOMATION = 'DIRECT_MAIL_AUTOMATION';
export const E_COMMERCE = 'E_COMMERCE';
export const E_SIGNATURE = 'E_SIGNATURE';
export const EMAIL = 'EMAIL';
export const ERP = 'ERP';
export const ETL = 'ETL';
export const EVENT_MANAGEMENT = 'EVENT_MANAGEMENT';
export const EXPERIENCE_MANAGEMENT = 'EXPERIENCE_MANAGEMENT';
export const FIELD_SERVICE = 'FIELD_SERVICE';
export const FORM_BUILDER = 'FORM_BUILDER';
export const FUNDRAISING_NON_PROFIT = 'FUNDRAISING_NON_PROFIT';
export const HELP_DESK = 'HELP_DESK';
export const IPAAS = 'IPAAS';
export const KNOWLEDGE_BASE = 'KNOWLEDGE_BASE';
export const LEAD_SCORING_ROUTING = 'LEAD_SCORING_ROUTING';
export const LEARNING_MANAGEMENT_SYSTEM = 'LEARNING_MANAGEMENT_SYSTEM';
export const LIVE_CHAT = 'LIVE_CHAT';
export const MARKETING_ANALYTICS = 'MARKETING_ANALYTICS';
export const MARKETING_AUTOMATION = 'MARKETING_AUTOMATION';
export const MESSAGING_NETWORK = 'MESSAGING_NETWORK';
export const PARTNER_MANAGEMENT = 'PARTNER_MANAGEMENT';
export const PAYMENTS = 'PAYMENTS';
export const PRODUCT_ANALYTICS = 'PRODUCT_ANALYTICS';
export const PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT';
export const PROPOSALS = 'PROPOSALS';
export const SALES_ANALYTICS = 'SALES_ANALYTICS';
export const SALES_COMPENSATION = 'SALES_COMPENSATION';
export const SALES_ENABLEMENT = 'SALES_ENABLEMENT';
export const SALES_ENGAGEMENT = 'SALES_ENGAGEMENT';
export const SALES_INTELLIGENCE = 'SALES_INTELLIGENCE';
export const SCHEDULING = 'SCHEDULING';
export const SENSITIVE_DATA = 'SENSITIVE_DATA';
export const SEO = 'SEO';
export const SESSION_REPLAYS = 'SESSION_REPLAYS';
export const SMS = 'SMS';
export const SOCIAL_MEDIA_MANAGEMENT = 'SOCIAL_MEDIA_MANAGEMENT';
export const SOCIAL_NETWORKS = 'SOCIAL_NETWORKS';
export const SPREADSHEETS = 'SPREADSHEETS';
export const SUBSCRIPTION_MANAGEMENT = 'SUBSCRIPTION_MANAGEMENT';
export const SURVEYS = 'SURVEYS';
export const TICKETING = 'TICKETING';
export const VIDEO = 'VIDEO';
export const WEBINARS = 'WEBINARS';
export const WORKFLOW_AUTOMATION = 'WORKFLOW_AUTOMATION';
export const WORKFORCE_MANAGEMENT = 'WORKFORCE_MANAGEMENT';